import {
  ClientPlatformAccountSchema,
  ClientPlatformSchema,
  ClientSchema,
} from '@ametista-ai/api-schema';
import { ApiResponse } from '@ametista-ai/api-schema/http/types';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/stores/api/apiClient';
import { clientsKeys } from './keys';

export type ClientsResponse = {
  clients: ClientSchema[];
  clientPlatforms: ClientPlatformSchema[];
  clientPlatformAccounts: ClientPlatformAccountSchema[];
};

export function useClients(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: clientsKeys.list(),
    queryFn: () => {
      return apiClient.get<ApiResponse<ClientsResponse>>(
        '/v1/clients?limit=1000',
        undefined,
        undefined
      );
    },
    enabled: options?.enabled ?? true,
    select: (response) => ({
      ...response,
      data: {
        ...response.data,
        clients: [...response.data.clients].sort((a, b) => a.name.localeCompare(b.name)),
      },
    }),
  });
}
